<template>
  <figure
    class="carousel-card"
    tabindex="0"
  >
    <img v-if="!isEditMode" v-lazy="imageSrc" class="carousel-card__img" :alt="imageAlt">
    <img v-else class="carousel-card__img" :src="imageSrc" :alt="imageAlt">
    <figcaption class="carousel-card__credit">
      <span v-if="imageCaption" aria-hidden="true">{{ imageCaption }}</span>
      <span v-if="imageCredit" aria-hidden="true">({{ imageCredit }})</span>
    </figcaption>
  </figure>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { processScImage } from '~/helpers/cloudinary-adapter'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'CarouselCard',

  props: {
    image: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    imageSrc () {
      const processed = processScImage(this.image, 'cloudinary_image_url_large')

      return processed.src
    },

    imageAlt () {
      const alt = this.image.alt

      if (!this.imageCredit) return alt

      return `${alt} (${this.imageCredit})`
    },

    imageCaption () {
      return this.image.imageCaption
    },

    imageCredit () {
      return this.image.imageCredit
    }
  }
}
</script>

<style lang="scss" scoped>

.carousel-card {
  display: flex;
  flex-direction: column;
  margin: 0 2px 10px 0;

  &__img {
    height: 320px;
    width: auto;

    @include tablet {
        height: 500px;
    }

    @include desktop {
        height: 800px;
    }
  }

  &__credit {
    @include font('030');

    letter-spacing: 0;
    margin-top: 10px;
    color: $color-slate-dark;
  }
}

</style>
